module.exports = __webpack_public_path__ + "img/i-swipe-8.36f87d52.png";